<template>
  <div>
    <div style="display: flex;">
      <div style="flex: 1;">
        <div class="tit-box type1 mgt20">
          <h1 class="tit-type1">과거 세무신고자료 간편 제출</h1>
        </div>
        <div class="submit-desc">당해 연도에 신고한 원천세 신고자료의 오류검증을 위해 과거 신고자료를 제출합니다.</div>
        <div class="submit-method">
          <div class="method-item">
            <span class="method-label" v-if="!props.isEntryPthPpup">방법1)</span>
            <button class="small bt-blue" @click="btnSmplPrsnt_click"><span>간편 제출하기</span></button><button class="small bt-bline" v-if="txftStmnDatRdt">제출완료 ({{ txftStmnDatRdt }})</button>
            <div class="method-desc">인증서로 조회하여 제출하는 방법입니다.<b>(인증서는 별도로 저장되지 않습니다.)</b></div>
          </div>
          <div class="method-item" v-if="!props.isEntryPthPpup">
            <span class="method-label">방법2)</span>
            <button class="small bt-blue" @click="btnPdfPrsnt_click"><span>직접 제출하기</span></button><button class="small bt-bline" v-if="txftStmnDatPdfRdt">제출완료 ({{ txftStmnDatPdfRdt }})</button>
            <div class="method-desc">홈택스에서 pdf 파일로 다운로드하여 제출하는 방법입니다.</div>
          </div>
        </div>
        <div>{{cprCrct.certname}}</div>
      </div>
    </div>
  </div>
  <div class="layer-btn">
    <btn :txt="'닫기'"
         @click="btnCancl_click"/>
    <btn :txt="'제출'"
         :color="'purple'"
         @click="btnRqt_click"/>
  </div>
</template>

<script setup>
import { initSmartaib4pc, loadSmartaib4pcScript } from "@/utils/smartaib4pc";
import {computed, defineEmits, defineProps, onMounted, reactive, ref} from "vue";
import {getStore, getUtils} from "@/utils/import";
import StmnSmplPrsntCnfm from "@/views/my-home/stmn-smpl-prsnt-cnfm.vue";
import StmnPdfPrsntCnfm from "@/views/my-home/stmn-pdf-prsnt-cnfm.vue";
import StmnPdfUpload from "@/views/my-home/stmn-pdf-upload.vue";

const {$cmmn, $alert, $axios, $popup} = getUtils();
const {$loading, $mber} = getStore();

const props = defineProps({
  fcltySn: {
    type: Number,
  },
  isEntryPthPpup: {
    type: Boolean,
    default: false,
  }
});

const fcltySn = computed(() => props.fcltySn);

const pdfFiles = ref([]);
const removedFileSns = ref([]);
const txftStmnDatPdfRdt = ref();
const txftStmnDatRdt = ref();

const btnSmplPrsnt_click = async () => {
  let prsntAt = true;
  const {signcertDer, signpriKey, certpwd, certname} = cprCrct;
  const isCprCrct = signcertDer && signpriKey && certpwd && certname;
  if (!isCprCrct) {
    prsntAt = false;
  }
  
  const popupOpts = {
    header: '간편제출',
    contentStyle: {
      'width': '700px',
    }
  }

  const emits = {'rgst': cprCrctRgst};
  const props = {prsntAt};
  $popup.show(StmnSmplPrsntCnfm, popupOpts, props, emits);
};

const btnPdfPrsnt_click = async () => {
  let prsntAt = true;
  if (pdfFiles.value.length === 0) {
    prsntAt = false;
  }

  const popupOpts = {
    header: '직접제출',
    contentStyle: {
      'width': '700px',
    }
  }
  
  const emits = {'rgst': pdfChoc};
  const props = {prsntAt};
  $popup.show(StmnPdfPrsntCnfm, popupOpts, props, emits);
};

const cprCrctRgst = async () => {
  initSmartaib4pc(fcltySn.value, {suc: cprCrctSuc, err: cprCrctErr});
}

const pdfChoc = async () => {
  const popupOpts = {
    header: '직접제출',
    contentStyle: {
      'width': '700px',
    }
  }

  const emits = {'rgst': pdfRgst};
  const props = {pdfFiles};
  $popup.show(StmnPdfUpload, popupOpts, props, emits);
}

const pdfRgst = async (data, dltData) => {
  removedFileSns.value = dltData;
  pdfFiles.value = data;
}

const cprCrct = reactive({
  signcertDer: '',
  signpriKey: '',
  certpwd: '',
  certname: '',
});

const cprCrctSuc = async (result) => {
  try {
    $loading.on();

    const {SIGNCERT_DER, SIGNPRI_KEY, CERTPWD, CERTNAME} = result;
    cprCrct.certname = CERTNAME;
    cprCrct.certpwd = CERTPWD;
    cprCrct.signcertDer = SIGNCERT_DER;
    cprCrct.signpriKey = SIGNPRI_KEY;
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const cprCrctErr = async (errCode, errMsg) => {
  await $alert('인증서 등록에 실패했습니다. 다시 시도해주세요.\n\n' + '에러메시지: [' + errCode + '] ' + errMsg);
  console.log('에러코드: ', errCode);
  console.log('에러메시지: ', errMsg);
}

const getRqtParams = () => {
  const {signcertDer, signpriKey, certpwd, certname} = cprCrct;

  const newPdfFiles = pdfFiles.value.filter(file => !file.fileSn);

  return {
    fcltySn: fcltySn.value,
    mberSn: $mber.mberSn,
    signcertDer,
    signpriKey,
    certpwd,
    certname,
    pdfFiles: newPdfFiles,
    dltFiles: removedFileSns.value,
  }
}

const btnRqt_click = async () => {
  try {
    $loading.on();

    await txftStmnDatModify();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const txftStmnDatModify = async () => {
  const params = getRqtParams();
  const {data} = await $axios.post('/api/fclty/txft-stmn-dat/modify', params);
  const {isSccs, msg, code} = data;

  if (!isSccs) {
    await $alert(msg);
    console.log(code);
    return false;
  }

  emits('compt');
  if (props.isEntryPthPpup) {
    await init();
  } else {
    emits('close');
  }

  // 재 수집 요청 'N'으로 수정
  await $axios.post('/api/fclty/wtpr-clct-mng-dl/modify', {fcltySn: fcltySn.value, clctRqtAt: 'N'});
}

const emits = defineEmits(['close', 'compt']);
const btnCancl_click = () => {
  emits('close');
}

const init = async () => {
  await loadSmartaib4pcScript();
  const txftStmnDatFiles = await $cmmn.fclty.getTxftStmnDatFilesByFcltySn(fcltySn.value);
  pdfFiles.value = txftStmnDatFiles;
  txftStmnDatPdfRdt.value = txftStmnDatFiles[0]?.rgstDttm;

  const txftStmnDat = await $cmmn.fclty.getTxftStmnDat(fcltySn.value);
  txftStmnDatRdt.value = $cmmn.date.getYmdhmsFormat(txftStmnDat?.RDT);
}

onMounted(async () => {
  try {
    $loading.on();

    await init();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})
</script>

<style scoped>
.submit-desc {
  margin: 5px 0;
  margin-bottom: 15px;
  color: #666;
}

.method-item {
  margin-bottom: 10px;
}

.method-item:last-child {
  margin-bottom: 0;
}

.method-label {
  display: inline-block;
  margin-right: 10px;
  font-weight: bold;
}

.method-desc {
  color: #666;
  padding: 10px;
  background: #f5f5f5;
}
</style>
